import moment from 'moment';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface AuthVerifyProps extends RouteComponentProps {
  logOut: (showNotification?: boolean) => void;
}

const AuthVerify: React.FC<AuthVerifyProps> = (props) => {
  props.history.listen(() => {
    const tokenTime = localStorage.getItem('tokenDate');

    if (tokenTime) {
      const exp = moment(tokenTime);
      const dif = moment().diff(exp, 'minutes');

      // Si han pasado más de 10 minutos, cerrar sesión
      if (dif >= 10) {
        props.logOut(true); // true = mostrar notificación
      } else {
        // Actualizar el timestamp de última actividad
        localStorage.setItem('tokenDate', moment().toString());
      }
    } else {
      // Si no hay tokenDate, cerrar sesión sin notificación
      props.logOut();
    }
  });

  return <div></div>;
};

export default withRouter(AuthVerify);
